import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaLinkedin, FaTwitter, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark text-white">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img src="/images/DZFD_logo.png" alt="DZF Distribution" className="h-36 mb-2" />
            <p className="text-gray-300 mb-4">
              Votre partenaire de confiance pour développer vos produits au Canada.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" className="text-gray-300 hover:text-white transition-colors">
                <FaFacebook size={20} />
              </a>
              <a href="https://linkedin.com" className="text-gray-300 hover:text-white transition-colors">
                <FaLinkedin size={20} />
              </a>
              <a href="https://twitter.com" className="text-gray-300 hover:text-white transition-colors">
                <FaTwitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">À Propos</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/clients" className="text-gray-300 hover:text-white transition-colors">Clients</Link></li>
              <li><Link to="/capabilities" className="text-gray-300 hover:text-white transition-colors">Capacités</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xl font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="mt-1 text-secondary" />
                <span className="text-gray-300">5163 Boulevard Métropolitain E, Saint-Leonard, Quebec H1R 1Z7</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhone className="text-secondary" />
                <a href="tel:+15145735871" className="text-gray-300 hover:text-white transition-colors">+1 (514) 473-5871</a>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhone className="text-secondary" />
                <a href="tel:+15142986254" className="text-gray-300 hover:text-white transition-colors">+1 (514) 298-6254</a>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-secondary" />
                <a href="mailto:info@dzfood.ca" className="text-gray-300 hover:text-white transition-colors">info@dzfood.ca</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} DZF Distribution. Tous droits réservés.
          </p>
          <div className="mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 text-sm hover:text-white mr-4 transition-colors">Politique de confidentialité</Link>
            <Link to="/terms" className="text-gray-400 text-sm hover:text-white transition-colors">Conditions d'utilisation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 